import { render, staticRenderFns } from "./TransferConversation.vue?vue&type=template&id=6ddfdc35"
import script from "./TransferConversation.vue?vue&type=script&lang=js"
export * from "./TransferConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports